export const mslConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSL_CLIENT_ID,
    authority: process.env.REACT_APP_MSL_AUTHORITY,
    knownAuthorities: ["necaidentity.b2clogin.com"],
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
  ],
};

export const apiRequest = {
  scopes: [process.env.REACT_APP_API_SCOPE],
};
